import React from 'react';
import Cookies from 'universal-cookie';
import Paper from '@material-ui/core/Paper';
import CircularProgress from "@material-ui/core/CircularProgress";

const config = require('../../../../../../../../controllers/config');

//css
import MainCss from './Main-css';
const useStyles = MainCss();

const content = (props) => {
    const classes = useStyles();
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    const urlProtocolo = `${config.URL_BACKEND}/protocoloLogistico/downloadFileProtocolo/${token}/protocolo`;
    return (
        <div className={classes.root}>
            <Paper className={classes.paper} align={'center'}>
                {props.state.isLoading &&
                    <div align="center">
                        <CircularProgress />
                    </div>
                }
                {!props.state.isLoading &&
                    <iframe src={urlProtocolo} className={classes.imagem}/>
                }
            </Paper>
        </div>
    );
};

export default content;